import React from 'react'
import * as styles from './NavLink.module.css'

import AgnosticLink from './AgnosticLink.js'

const NavLink = ({ className, href, children, rel, target, ...rest }) => {
  const external = href.startsWith('http')
  const classes = [styles.li]
  if (className) classes.push(className)
  if (rest.highlighted) classes.push(styles.highlighted)
  if (rest.rotated) classes.push(styles.rotated)
  const classNames = classes.join(' ')

  if (external)
    return (
      <li className={classNames}>
        <AgnosticLink {...{ href, rel, target }}>{children}</AgnosticLink>
      </li>
    )
  else
    return (
      <li className={`${styles.li} ${className}`}>
        <AgnosticLink {...{ href, rel, target }}>{children}</AgnosticLink>
      </li>
    )
}

export default NavLink
